import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'uui-expansion-panel-body',
  styleUrl: 'uui-expansion-panel-body.css',
  shadow: true
})

/**
 * @slot default - Slot for the content of the panel.
 */
export class UuiExpansionPanelBody {
  @Element() el: HTMLElement;
  @Prop({ mutable: false, reflect: false }) panelId: string = '';

  render() {
    return (
      <Host>
        <div class="uui-expansion-body-wrapper">
          <div
            role="region"
            class="uui-expansion-body-content"
            id="uui-expansion-body"
            aria-labelledby={this.panelId}
          >
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
